// UID: BWR-IRS_SS4_EIN-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2347
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsBetweenJanAndMidFeb,
  IsBetweenMidAprilMidMay,
  IsBetweenMidMayMidAug,
  IsBetweenMidAugMidOct,
  HasApplicantFiledTR,
  IsForProfit,
} from '../rules';
import IsBetweenMidFebMidApril from '../rules/IsBetweenMidFebMidApril';
import IsBusinessEstablishedEqualTo from '../rules/IsBusinessEstablishedEqualTo';
import IsBusinessEstablishedLessThan from '../rules/IsBusinessEstablishedLessThan';

class IrsSS4Ruleset implements Ruleset {
  public forProfitResult = (
    data: Partial<ApplicationFormValues>
  ): RulesetResult => {
    const establishedLessThanTwoYearsAgo =
      IsBusinessEstablishedLessThan.setYears(2).evaluate(data);

    const establishedEqualToTwoYearsAgo =
      IsBusinessEstablishedEqualTo.setYears(2).evaluate(data);

    if (establishedLessThanTwoYearsAgo || establishedEqualToTwoYearsAgo)
      return RulesetResult.REQUIRED;

    return RulesetResult.HIDDEN;
  };

  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isForProfit = IsForProfit.evaluate(data);
    if (isForProfit) return this.forProfitResult(data);

    const businessEstablishedLessThanTwoYearsAgo =
      IsBusinessEstablishedLessThan.setYears(2).evaluate(data);
    const hasApplicantEverFiledTR = HasApplicantFiledTR.evaluate(data);
    if (businessEstablishedLessThanTwoYearsAgo) return RulesetResult.REQUIRED;

    const businessEstablishedTwoYearsAgo =
      IsBusinessEstablishedEqualTo.setYears(2).evaluate(data);

    const isBetweenJanAndMidOct = [
      IsBetweenJanAndMidFeb,
      IsBetweenMidFebMidApril,
      IsBetweenMidAprilMidMay,
      IsBetweenMidMayMidAug,
      IsBetweenMidAugMidOct,
    ].some((Is) => Is.evaluate(data));

    if (
      businessEstablishedTwoYearsAgo &&
      isBetweenJanAndMidOct &&
      !hasApplicantEverFiledTR
    )
      return RulesetResult.REQUIRED;

    return RulesetResult.HIDDEN;
  };
}

export default new IrsSS4Ruleset();
